<div class="
    fusion-fullwidth
    fullwidth-box
    fusion-builder-row-1 fusion-parallax-none
    nonhundred-percent-fullwidth
    non-hundred-percent-height-scrolling
  " style="
    background-color: rgba(255, 255, 255, 0);
    background-image: url('/wp-content/uploads/2015/12/about-call-to-action-57862405-1024x630.jpg');
    background-position: center bottom;
    background-repeat: no-repeat;
    padding-top: 100px;
    padding-right: 30px;
    padding-bottom: 20px;
    padding-left: 30px;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  ">
  <div class="fusion-builder-row fusion-row">
    <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_1
        fusion-builder-column-0
        fusion-one-full
        fusion-column-first
        fusion-column-last
        1_1
      " style="margin-top: 0px; margin-bottom: 0px">
      <div class="fusion-column-wrapper" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
        <style type="text/css">
          @media only screen and (max-width: 700px) {
            .fusion-title.fusion-title-1 {
              margin-top: 10px !important;
              margin-bottom: 10px !important;
            }
          }
        </style>
        <div class="
            fusion-title
            title
            fusion-title-1
            fusion-sep-none
            fusion-title-text
            fusion-title-size-one
          " style="margin-top: 0px; margin-bottom: 10px">
          <h1 class="title-heading-left" style="margin: 0">
            <h1 style="text-align: center">
              <span style="color: #ffffff">IMPRESE</span>
            </h1>
          </h1>
        </div>
        <div style="color: white; font-weight: 500; text-align: center">
          Questa vetrina è riservata esclusivamente alle lavorazioni in opera
          (fornitura e posa o solo posa), non è adibita a commercializzazione
          dei materiali.
        </div>
        <div class="fusion-clearfix"></div>
      </div>
    </div>
    <form [formGroup]="searchForm" id="search-appform">
      <style type="text/css">
        input::-webkit-input-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-webkit-input-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Firefox < 19 */
        input:-moz-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-moz-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Firefox > 19 */
        input::-moz-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-moz-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Internet Explorer 10 */
        input:-ms-input-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-ms-input-placeholder {
          color: #ffffff;
          transition: none;
        }
      </style>
      <div style="
          content: '';
          display: table;
          clear: both;
          width: 100%;
          padding-top: 15px;
        ">
        <div id="form_wrapper" style="display: flex; justify-content: space-around">
          <style type="text/css">
            @media only screen and (max-width: 700px) {
              #form_wrapper {
                flex-wrap: wrap;
              }
            }
          </style>

          <!-- RAGIONE SOCIALE -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(50% - ((4% + 4%) * 0.4));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-building fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <input style="
                        font-size: 16px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                      " class="ng-app-input" type="text" formControlName="companyName" placeholder="RAGIONE SOCIALE" />
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
          <!-- LOCALITA' -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(50% - ((4% + 4%) * 0.4));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-map-marker-alt fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <input style="
                        font-size: 16px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                      " class="ng-app-input" type="text" formControlName="companyLocation"
                      placeholder="LOCALITA&#8217; (Città, Provincia o Cap)" />
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- INDIRIZZO
          <div class="fusion-layout-column fusion_builder_column fusion_builder_column_2_5 fusion-builder-column-2 fusion-two-fifth 2_5"
              style='margin-top:0px;margin-bottom:0px;width:40%;width:calc(30.00% - ((4% + 4%) * 0.3333));'>
              <div class="fusion-column-wrapper"
                  style="background-color:#ffffff;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                  data-bg-url="">
                  <ul class="fusion-checklist fusion-checklist-2" style="font-size:16px;line-height:27.2px;padding: 3px;">
                      <li class="fusion-li-item"><span style="height:27.2px;width:27.2px;margin-right:11.2px; margin-right: 10px;padding-top: 5px;padding-right: 0;padding-left: 10px;"
                              class="icon-wrapper circle-no"><i class="fusion-li-icon fa-map-marker-alt fas"
                                  style="color:#333333;padding-top: 15px;padding-left: 8px;"></i></span>
                          <div class="fusion-li-item-content" style="margin-left:45px;">
                              <input style="font-size: 16px !important;font-weight: 300;letter-spacing: 1px !important;padding-bottom: 0 !important;padding-left: 5px !important;"
                                  class="ng-app-input" type="text" formControlName="companyAddress" placeholder="INDIRIZZO">
                          </div>
                      </li>
                  </ul>
                  <div class="fusion-clearfix"></div>
              </div>
          </div> -->
      <div style="
          content: '';
          display: table;
          clear: both;
          width: 100%;
          padding-top: 15px;
        ">
        <div id="form_wrapper" style="display: flex; justify-content: space-between">
          <style type="text/css">
            @media only screen and (max-width: 700px) {
              #form_wrapper {
                flex-wrap: wrap;
              }
            }
          </style>

          <!-- SETTORE AZIENDA -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(25% - ((4% + 4% + 4%) * 0.25));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                padding-right: 10px;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-server fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <select formControlName="companySectorCode" style="
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        font-size: 15px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                        border: none;
                        width: 100%;
                      ">
                      <option [ngValue]="null">SETTORE AZIENDA</option>
                      <option [ngValue]="sectorCompany.code" *ngFor="let sectorCompany of sectorCompanyList">
                        {{ sectorCompany.description }}
                      </option>
                    </select>
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>

          <!-- APPALTATORE GENERALE -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(30% - ((4% + 4% + 4%) * 0.25));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                padding-right: 10px;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-hard-hat fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <select formControlName="companyGeneralContractor" style="
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        font-size: 14px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                        border: none;
                        width: 100%;
                      ">
                      <option [ngValue]="null">APPALTATORE GENERALE</option>
                      <option [ngValue]="true">SI</option>
                      <option [ngValue]="false">NO</option>
                    </select>
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
          <!-- APPALTATORE DI SETTORE O PARZIALE -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(30% - ((4% + 4% + 4%) * 0.25));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                padding-right: 10px;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-hard-hat fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <select formControlName="companySectorContractor" style="
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        font-size: 14px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                        border: none;
                        width: 100%;
                      ">
                      <option [ngValue]="null">APPALTATORE DI SETTORE</option>
                      <option [ngValue]="true">SI</option>
                      <option [ngValue]="false">NO</option>
                    </select>
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
          <!-- DIPENDENTI -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(20% - ((4% + 4% + 4%) * 0.25));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                padding-right: 10px;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-briefcase fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <select formControlName="companySize" style="
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        font-size: 15px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                        border: none;
                        width: 100%;
                      ">
                      <option [ngValue]="null">DIPENDENTI</option>
                      <option [ngValue]="companySize.code" *ngFor="let companySize of companySizeList">
                        {{ companySize.description }}
                      </option>
                    </select>
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-8
          fusion-one-full
          fusion-column-first
          fusion-column-last
          1_1
        " style="margin-top: 0px; margin-bottom: 0px">
        <div class="fusion-column-wrapper" style="
            padding: 30px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            background-size: cover;
            height: auto;
          " data-bg-url="">
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
          <div class="fusion-button-wrapper fusion-aligncenter">
            <style type="text/css">
              .fusion-button.button-1 {
                border-radius: 0px;
              }
            </style>
            <a (click)="searchCompanies()" class="
                fusion-button
                button-flat button-xlarge button-default button-1
                fusion-button-default-span fusion-button-default-type
              " target="_self"><span class="fusion-button-text">CERCA</span></a>
          </div>
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="
    fusion-layout-column
    fusion_builder_column
    fusion_builder_column_1_1
    fusion-builder-column-22
    fusion-one-full
    fusion-column-first
    fusion-column-last
    1_1
  " style="margin-top: 0px; margin-bottom: 0px">
  <div class="fusion-column-wrapper" style="
      padding: 0px;
      background-position: left top;
      background-repeat: no-repeat;
      background-size: cover;
      height: auto;
    " data-bg-url="">
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
    <div class="fusion-clearfix"></div>
  </div>
</div>
<!-- CARDS -->
<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-date-and-formats .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-1 .tooltip-shortcode {
    color: #ffa626;
  }

  #main .fusion-fullwidth.fusion-builder-row-1 .post .blog-shortcode-post-title a:hover {
    color: #ffa626;
  }
</style>
<div *ngIf="!publicCompanyCards || publicCompanyCards.length === 0"
  style="text-align: center; margin-top: 8vh; margin-bottom: 8vh">
  <p style="font-size: 2rem">
    <strong>Non ci sono aziende da visualizzare</strong>
  </p>
</div>
<div *ngFor="let companyCard of publicCompanyCards">
  <div class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-2
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
    " style="
      background-color: rgba(255, 255, 255, 0);
      background-position: center center;
      background-repeat: no-repeat;
      padding-top: 0px;
      padding-bottom: 0px;
      max-width: 1170px;
      margin: auto;
      box-shadow: 0 5px 25px -2px grey;
      border-radius: 0.45rem;
    ">
    <div class="fusion-builder-row fusion-row">
      <div id="heading_card" style="
          background-color: #ffa526b0;
          height: auto;
          border-top-right-radius: 0.45rem;
          border-top-left-radius: 0.45rem;
          content: '';
          clear: both;
          display: table;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        ">
        <style type="text/css">
          @media only screen and (max-width: 700px) {
            #heading_card {
              flex-wrap: wrap;
            }

            .rating {
              padding-bottom: 10px;
            }

            .logo {
              justify-content: center;
              align-items: center;
            }
          }
        </style>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_3_4
            fusion-builder-column-10
            fusion-three-fourth
            fusion-column-first
            3_4
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 60%;
            height: inherit;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
              height: auto;
              padding: 10px 0;
              min-height: 90px;
            " data-bg-url="">
            <div class="fusion-text">
              <h3 data-fontsize="28" data-lineheight="40.6px" class="fusion-responsive-typography-calculated"
                style="--fontSize: 28; line-height: 1.45; padding: 0 40px">
                <strong *ngIf="companyCard.profile.companyName">{{
                  companyCard.profile.companyName
                  }}</strong>
                <strong *ngIf="!companyCard.profile.companyName">
                  <em>"Nome azienda"</em>
                </strong>
              </h3>
            </div>
            <div class="fusion-text" style="padding: 0 40px">
              <span *ngIf="companyCard.profile.address">{{
                companyCard.profile.address
                }}</span>
              <span *ngIf="!companyCard.profile.address"><em>"indirizzo"</em></span>
              <span *ngIf="companyCard.profile.addressNumber">, {{ companyCard.profile.addressNumber }}</span>
              <span *ngIf="!companyCard.profile.addressNumber">, <em>"n°"</em></span>
              <span *ngIf="companyCard.profile.zipCode">
                – {{ companyCard.profile.zipCode }}</span>
              <span *ngIf="!companyCard.profile.zipCode">
                – <em>"CAP"</em></span>
              <span *ngIf="companyCard.profile.city">
                – {{ companyCard.profile.city }}</span>
              <span *ngIf="!companyCard.profile.city"> – <em>"città"</em></span>
              <span *ngIf="companyCard.profile.provinceCode">
                ({{ companyCard.profile.provinceCode }})
              </span>
              <span *ngIf="!companyCard.profile.provinceCode">
                <em> (provincia)</em>
              </span>
            </div>
            <div class="fusion-clearfix"></div>
          </div>
        </div>
        <div *ngIf="companyCard.rating != null" class="
            rating
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_4
            fusion-builder-column-11
            fusion-one-fourth
            fusion-column-last
            1_4
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 25%;
            width: calc(25% - ((4%) * 0.25));

            display: flex;
            justify-content: right;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
            " data-bg-url="">
            <div class="fusion-text main-rating"
              *ngIf="profile.ratingEnabled || profile.customerId === companyCard.profile.customerId">
              <!-- <ul style="list-style: none; display: flex;">
                <li *ngFor="let x of (companyCard.rating | toArray)">
                  <i value="x" class="fusion-li-icon fa-star fas"></i>
                </li>
                <li *ngFor="let x of (6-companyCard.rating | toArray)">
                  <i value=x class="fusion-li-icon fa-star far"></i>
                </li>
              </ul> -->

              <div class="rating" *ngIf="companyCard.rating >= 1">
                <i class="fusion-li-icon fa-star fas"></i>
              </div>
              <div class="rating" *ngIf="
                  companyCard.rating > 0 &&
                  companyCard.rating < 1 &&
                  companyCard.rating % 1 != 0
                ">
                <i class="fusion-li-icon fas fa-star-half-alt"></i>
              </div>
              <div class="rating" *ngIf="companyCard.rating < 1 && companyCard.rating % 1 == 0">
                <i class="fusion-li-icon fa-star far"></i>
              </div>

              <div class="rating" *ngIf="companyCard.rating >= 2">
                <i class="fusion-li-icon fa-star fas"></i>
              </div>
              <div class="rating" *ngIf="
                  companyCard.rating > 1 &&
                  companyCard.rating < 2 &&
                  companyCard.rating % 1 != 0
                ">
                <i class="fusion-li-icon fas fa-star-half-alt"></i>
              </div>
              <div class="rating" *ngIf="
                  (companyCard.rating < 2 && companyCard.rating % 1 == 0) ||
                  companyCard.rating == 0.5
                ">
                <i class="fusion-li-icon fa-star far"></i>
              </div>

              <div class="rating" *ngIf="companyCard.rating >= 3">
                <i class="fusion-li-icon fa-star fas"></i>
              </div>
              <div class="rating" *ngIf="
                  companyCard.rating > 2 &&
                  companyCard.rating < 3 &&
                  companyCard.rating % 1 != 0
                ">
                <i class="fusion-li-icon fas fa-star-half-alt"></i>
              </div>
              <div class="rating" *ngIf="
                  (companyCard.rating < 3 && companyCard.rating % 1 == 0) ||
                  companyCard.rating == 1.5 ||
                  companyCard.rating == 0.5
                ">
                <i class="fusion-li-icon fa-star far"></i>
              </div>

              <div class="rating" *ngIf="companyCard.rating >= 4">
                <i class="fusion-li-icon fa-star fas"></i>
              </div>
              <div class="rating" *ngIf="
                  companyCard.rating > 3 &&
                  companyCard.rating < 4 &&
                  companyCard.rating % 1 != 0
                ">
                <i class="fusion-li-icon fas fa-star-half-alt"></i>
              </div>
              <div class="rating" *ngIf="
                  (companyCard.rating < 4 && companyCard.rating % 1 == 0) ||
                  companyCard.rating == 2.5 ||
                  companyCard.rating == 1.5 ||
                  companyCard.rating == 0.5
                ">
                <i class="fusion-li-icon fa-star far"></i>
              </div>

              <div class="rating" *ngIf="companyCard.rating >= 5">
                <i class="fusion-li-icon fa-star fas"></i>
              </div>
              <div class="rating" *ngIf="
                  companyCard.rating > 4 &&
                  companyCard.rating < 5 &&
                  companyCard.rating % 1 != 0
                ">
                <i class="fusion-li-icon fas fa-star-half-alt"></i>
              </div>
              <div class="rating" *ngIf="
                  (companyCard.rating < 5 && companyCard.rating % 1 == 0) ||
                  companyCard.rating == 3.5 ||
                  companyCard.rating == 2.5 ||
                  companyCard.rating == 1.5 ||
                  companyCard.rating == 0.5
                ">
                <i class="fusion-li-icon fa-star far"></i>
              </div>
              <div class="rating-viewer">DETTAGLI</div>
              <style>
                .rating-viewer {
                  text-align: center;
                  border: 1px solid #606060;
                  font-size: 14px;
                }

                .rating {
                  display: inline-block;
                }

                .sub-rating {
                  display: none;
                  position: absolute;
                  background-color: #ffa526b0;
                  z-index: 1000;
                  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
                  padding: 4px;
                  font-size: 14px;
                }

                .rating:hover .sub-rating {
                  display: block;
                }
              </style>
            </div>
            <div class="sub-rating">
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.fiveStarAmount }}</b>
              </div>
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star-half-alt fas"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.fourStarHalfAmount }}</b>
              </div>
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.fourStarAmount }}</b>
              </div>
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star-half-alt fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.threeStarHalfAmount }}</b>
              </div>
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.threeStarAmount }}</b>
              </div>
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star-half-alt fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.twoStarHalfAmount }}</b>
              </div>
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.twoStarAmount }}</b>
              </div>

              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star-half-alt fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.oneStarHalfAmount }}</b>
              </div>
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.oneStarAmount }}</b>
              </div>
              <div class="fusion-text">
                <div class="rating">
                  <i class="fusion-li-icon fa-star-half-alt fas"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                <div class="rating">
                  <i class="fusion-li-icon fa-star far"></i>
                </div>
                &nbsp;&nbsp;<b>{{ companyCard.zeroStarHalfAmount }}</b>
              </div>



            </div>


            <div class="fusion-clearfix"></div>

          </div>

        </div>
        <div style="min-width: 160px">
          <img *ngIf="companyCard.bronzeCertification" style="width: 70px; height: 70px; margin:5px"
            src="https://www.skimmingbpe.com/wp-content/uploads/Bronzo.svg" />
          <img *ngIf="companyCard.silverCertification" style="width: 70px; height: 70px; margin:5px"
            src="https://www.skimmingbpe.com/wp-content/uploads/Argento.svg" />
          <img *ngIf="companyCard.goldCertification" style="width: 70px; height: 70px; margin:5px"
            src="https://www.skimmingbpe.com/wp-content/uploads/Gold.svg" />
          <img *ngIf="companyCard.platinumCertification" style="width: 70px; height: 70px; margin:5px"
            src="https://www.skimmingbpe.com/wp-content/uploads/Platino.svg" />
          <img *ngIf="companyCard.greenCertification" style="width: 70px; height: 70px; margin:5px"
            src="https://www.skimmingbpe.com/wp-content/uploads/Sostenibilita_albero.svg" />
        </div>
      </div>
      <div id="card_details" style="
          content: '';
          clear: both;
          display: table;
          width: 100%;
          padding: 15px 20px;
        ">
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-column-12
            fusion-one-third
            fusion-column-first
            1_3
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: calc(33.33% - ((4% + 6% + 4%) * 0.3333));
            margin-left: 2%;
            margin-right: 2%;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 20px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
              height: auto;
              line-height: 0.9;
            " data-bg-url="">
            <span class="
                logo
                fusion-imageframe
                imageframe-none imageframe-1
                hover-type-none
              " style="display: flex"><img *ngIf="!companyCard.profile.logo; else logo" loading="lazy"
                src="/wp-content/uploads/2020/02/Skimming-retina-logo-desktop.png" width="186" alt=""
                title="Skimming retina logo desktop" class="img-responsive wp-image-1190" />
              <ng-template #logo>
                <img loading="lazy" src="{{ companyCard.profile.logo.documentUrl }}" width="186" alt=""
                  title="Skimming retina logo desktop" class="img-responsive wp-image-1190" />
              </ng-template>
            </span>
            <div class="fusion-sep-clear"></div>
            <div class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
            <div class="fusion-sep-clear"></div>
            <div class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
            <div class="fusion-text">
              <p>
                <strong>GARE PARTECIPATE:</strong>
                {{ companyCard.profile.stats.partecipatedTenders.total }}
              </p>
            </div>
            <div class="fusion-text">
              <p>
                <strong>GARE VINTE:</strong>
                {{
                checkNumber(companyCard.profile.stats.partecipatedTenders.won)
                }}
              </p>
            </div>
            <div class="fusion-text">
              <p>
                <strong>GARE CREATE:</strong>
                {{ companyCard.profile.stats.myTenders.total }}
              </p>
            </div>
            <div class="fusion-sep-clear"></div>
            <div class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
            <div class="fusion-text">
              <p *ngIf="companyCard.profile.generalContractor">
                <strong>APPALTATORE GENERALE:</strong> SI
              </p>
              <p *ngIf="!companyCard.profile.generalContractor">
                <strong>APPALTATORE GENERALE:</strong> NO
              </p>
            </div>
            <div class="fusion-text">
              <p *ngIf="companyCard.profile.sectorOrPartialContractor">
                <strong>APPALTATORE PARZIALE:</strong> SI
              </p>
              <p *ngIf="!companyCard.profile.sectorOrPartialContractor">
                <strong>APPALTATORE PARZIALE:</strong> NO
              </p>
            </div>
            <div class="fusion-clearfix"></div>
          </div>
        </div>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-column-13
            fusion-one-third
            1_3
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: calc(33.33% - ((4% + 6% + 4%) * 0.3333));
            margin-left: 3%;
            margin-right: 3%;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 20px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
              height: auto;
              line-height: 0.9;
            " data-bg-url="">
            <div class="fusion-text">
              <p><strong>TIPO IMPRESA:</strong></p>
            </div>
            <div class="fusion-text">
              <p *ngIf="companyCard.profile.typeCode">
                {{ getTypeCompany(companyCard.profile.typeCode) }}
              </p>
              <p *ngIf="!companyCard.profile.typeCode">
                <em>nessuna informazione</em>
              </p>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>SETTORE IMPRESA:</strong></p>
            </div>
            <div class="fusion-text">
              <!-- <p *ngIf="companyCard.profile.sectorCodes.length == 0">
                {{ companyCard.profile.sectorCodes }}
              </p>
              <p *ngIf="!companyCard.profile.sectorCodes.length == 0">
                <em>nessuna informazione</em>
              </p> -->
              <!-- {{print(companyCard.profile)}} -->
              <p *ngIf="!companyCard.profile.sectorsCodes.length == 0"></p>
              <p *ngFor="let sector of companyCard.profile.sectorsCodes">
                {{ getSectorCompany(sector) }}
              </p>
              <p *ngIf="companyCard.profile.sectorsCodes.length == 0">
                <em>nessuna informazione</em>
              </p>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>DATORE DI LAVORO:</strong></p>
            </div>
            <div class="fusion-text">
              <p *ngIf="companyCard.profile.employer">
                {{ companyCard.profile.employer }}
              </p>
              <p *ngIf="!companyCard.profile.employer">
                <em>nessuna informazione</em>
              </p>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>DIPENDENTI<br />(compreso il titolare):</strong></p>
            </div>
            <div class="fusion-text">
              <p *ngIf="companyCard.profile.companySizeCode">
                {{ getDimentionCompany(companyCard.profile.companySizeCode) }}
              </p>
              <p *ngIf="!companyCard.profile.companySizeCode">
                <em>nessuna informazione</em>
              </p>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>REFERENZE:</strong></p>
            </div>
            <div *ngIf="companyCard.profile.references.length">
              <div *ngFor="
                  let refer of companyCard.profile.references;
                  let i = index
                " class="fusion-text">
                <p>{{ refer.name }}</p>
              </div>
            </div>
            <div *ngIf="!companyCard.profile.references.length">
              <div class="fusion-text">
                <p><em>nessuna referenza</em></p>
              </div>
            </div>
            <div class="fusion-clearfix"></div>
          </div>
        </div>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-column-14
            fusion-one-third
            fusion-column-last
            1_3
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: calc(33.33% - ((4% + 6% + 4%) * 0.3333));
            margin-left: 2%;
            margin-right: 2%;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 20px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
              height: auto;
              line-height: 0.9;
            " data-bg-url="">
            <div class="fusion-text">
              <p><strong>SPECIALIZZAZIONI:</strong></p>
            </div>
            <div *ngIf="companyCard.profile.specializations.length">
              <div *ngFor="
                  let spec of companyCard.profile.specializations;
                  let i = index
                " class="fusion-text">
                <p>{{ GetSpecializationDescription(spec.code) }}</p>
              </div>
            </div>
            <div *ngIf="!companyCard.profile.specializations.length">
              <div class="fusion-text">
                <p><em>nessuna specializzazione</em></p>
              </div>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>CERTIFICAZIONI:</strong></p>
            </div>
            <div *ngIf="companyCard.profile.certifications.length">
              <div *ngFor="
                  let certif of companyCard.profile.certifications;
                  let i = index
                " class="fusion-text">
                <p>{{ certif.name }}</p>
              </div>
            </div>
            <div *ngIf="!companyCard.profile.certifications.length">
              <div class="fusion-text">
                <p><em>nessuna certificazione</em></p>
              </div>
            </div>
            <br />
            <br />

            <div class="fusion-text">
              <p><strong>ATTESTATI:</strong></p>
            </div>
            <div *ngIf="companyCard.profile.certificates.length">
              <div *ngFor="
                  let certificate of companyCard.profile.certificates;
                  let i = index
                " class="fusion-text">
                <p>{{ certificate.name }}</p>
              </div>
            </div>
            <div *ngIf="!companyCard.profile.certificates.length">
              <div class="fusion-text">
                <p><em>nessun attestato</em></p>
              </div>
            </div>

            <!-- <br />
            <br />
            <div class="fusion-text">
              <p><strong>ULTIMA DATA DI PARTECIPAZIONE:</strong></p>
            </div>
            <div *ngIf="
                companyCard.lastParticipationDate != null &&
                companyCard.lastParticipationDate != undefined
              ">
              <div class="fusion-text">
                <p>
                  {{ companyCard.lastParticipationDate | date: "dd/MM/yyyy" }}
                </p>
              </div>
            </div>
            <div *ngIf="
                companyCard.lastParticipationDate == null &&
                companyCard.lastParticipationDate == undefined
              ">
              <div class="fusion-text">
                <p>nessuna partecipazione</p>
              </div>
            </div>
            <br />
            <br /> -->

            <!-- Button that shows only if you are a professional

            -->
            <div *ngIf="profile">
              <div class="fusion-button-wrapper" (click)="changeModal(); getCompanyInfo(companyCard)">
                <style type="text/css">
                  .fusion-button.button-1 {
                    border-radius: 0px;
                  }
                </style>
                <div class="
                    fusion-button
                    button-flat
                    fusion-button-default-size
                    button-default button-1
                    fusion-button-default-span fusion-button-default-type
                  ">
                  <span class="fusion-button-text">INVITA AD UNA GARA</span>
                </div>
              </div>
            </div>
            <div class="fusion-clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="
      fusion-layout-column
      fusion_builder_column
      fusion_builder_column_1_1
      fusion-builder-column-22
      fusion-one-full
      fusion-column-first
      fusion-column-last
      1_1
    " style="margin-top: 0px; margin-bottom: 0px">
    <div class="fusion-column-wrapper" style="
        padding: 0px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: cover;
        height: auto;
      " data-bg-url="">
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
      <div class="fusion-clearfix"></div>
    </div>
  </div>
</div>
<!-- /CARDS -->

<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-3 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-3 .fusion-filters .fusion-filter.fusion-active a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-3 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-3 .fusion-filters .fusion-filter.fusion-active a,
  .fusion-fullwidth.fusion-builder-row-3 .fusion-date-and-formats .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-3 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-3 .tooltip-shortcode {
    color: #ffa626;
  }

  #main .fusion-fullwidth.fusion-builder-row-3 .post .blog-shortcode-post-title a:hover {
    color: #ffa626;
  }
</style>
<div class="
    fusion-fullwidth
    fullwidth-box
    fusion-builder-row-4
    nonhundred-percent-fullwidth
    non-hundred-percent-height-scrolling
  " style="
    background-color: rgba(255, 255, 255, 0);
    background-position: center center;
    background-repeat: no-repeat;
    padding-top: 0px;
    padding-right: 30px;
    padding-bottom: 0px;
    padding-left: 30px;
  ">
  <div class="fusion-builder-row fusion-row" *ngIf="showMoreCompanies">
    <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_1
        fusion-builder-column-23
        fusion-one-full
        fusion-column-first
        fusion-column-last
        1_1
      " style="margin-top: 0px; margin-bottom: 0px">
      <div class="fusion-column-wrapper" style="
          padding: 0px;
          background-position: left top;
          background-repeat: no-repeat;
          background-size: cover;
          height: auto;
        " data-bg-url="">
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
        <div class="fusion-button-wrapper fusion-aligncenter">
          <style type="text/css">
            .fusion-button.button-2 {
              border-radius: 0px;
            }
          </style>
          <a class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-default button-2
              fusion-button-default-span fusion-button-default-type
            " (click)="loadMoreCards()" target="_self"><span class="fusion-button-text">MOSTRA ALTRO</span></a>
        </div>
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
        <div class="fusion-clearfix"></div>
      </div>
    </div>
  </div>
</div>
<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-4 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-4 .fusion-filters .fusion-filter.fusion-active a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-4 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-4 .fusion-filters .fusion-filter.fusion-active a,
  .fusion-fullwidth.fusion-builder-row-4 .fusion-date-and-formats .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-4 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-4 .tooltip-shortcode {
    color: #ffa626;
  }

  #main .fusion-fullwidth.fusion-builder-row-4 .post .blog-shortcode-post-title a:hover {
    color: #ffa626;
  }
</style>
<div [ngStyle]="{ display: display }" class="fusion-modal modal fade modal-1 modal-invite in" tabindex="-1"
  role="dialog" id="invite-modal">
  <style type="text/css">
    .modal-1 .modal-header,
    .modal-1 .modal-footer {
      border-color: #ebebeb;
    }
  </style>
  <div class="modal-dialog modal-lg">
    <div class="modal-content fusion-modal-content" style="background-color: #f5f5f5">
      <div class="modal-header">
        <button class="close" type="button" (click)="changeModal()">×</button>
        <h3 class="modal-title fusion-responsive-typography-calculated" id="modal-heading-1" data-fontsize="28"
          data-lineheight="40.6px" style="--fontSize: 28; line-height: 1.45"
          *ngIf="currentCompany != null && currentCompany != undefined">
          INVITA {{ currentCompany.profile.companyName | uppercase }}!
        </h3>
      </div>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- CARDS -->
        <div class="modal-body fusion-clearfix" *ngIf="
            userTenders != null &&
            userTenders != undefined &&
            userTenders.length !== 0
          ">
          <div *ngFor="let card of userTenders">
            <div class="
                fusion-layout-column
                fusion_builder_column
                fusion_builder_column_1_1
                fusion-builder-nested-column-5
                fusion-one-full
                fusion-column-first
                fusion-column-last
                1_1
              " style="margin-top: 0px; margin-bottom: 0px">
              <div class="fusion-column-wrapper fusion-column-wrapper-5" style="
                  background-color: var(--ng-app-light-grey-color);
                  padding: 0px 0px 10px 20px;
                  background-position: left top;
                  background-repeat: no-repeat;
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                " data-bg-url="">
                <div class="fusion-builder-row-2" style="padding-right: 20px">
                  <div class="fusion-text">
                    <p class="ng-tender-title">
                      <strong>{{ card.title }}</strong>
                    </p>
                  </div>
                  <div *ngIf="card.customer" style="
                      font-family: Montserrat, Arial, Helvetica, sans-serif;
                      margin-bottom: 5px;
                    ">
                    <span style="height: 25px; width: 25px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                        class="fusion-li-icon fa-share-alt fas"
                        style="color: var(--ng-app-theme-yellow-color)"></i></span>
                    <strong style="
                        padding: 3px 0px;
                        font-size: 16px;
                        color: var(--ng-app-theme-yellow-color);
                      ">
                      Condivisa da: {{ card.customer }}</strong>
                  </div>
                  <div class="ng-tender-description">
                    <h5 style="font-size: 17px">{{ card.description }}</h5>
                  </div>
                </div>
                <div class="fusion-builder-row fusion-builder-row-inner fusion-row" style="padding-right: 20px">
                  <div class="
                      fusion-layout-column
                      fusion_builder_column
                      fusion_builder_column_1_2
                      fusion-builder-nested-column-1
                      fusion-one-half
                      fusion-column-first
                      1_2
                    " style="
                      margin-top: 10px;
                      margin-bottom: 10px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                      margin-right: 4%;
                    ">
                    <div class="fusion-column-wrapper fusion-column-wrapper-1">
                      <div class="fusion-text">
                        <h5>
                          Dal
                          {{ getFormattedDate(card.expectedStartDate) }} al
                          {{ getFormattedDate(card.expectedEndDate) }}
                        </h5>
                        <h5>{{ card.province }}</h5>
                        <h5>{{ getCategoryName(card.category) }}</h5>
                      </div>
                    </div>
                  </div>
                  <div style="float: right">
                    <label style="font-weight: bold" class="control control-radio">
                      Seleziona gara
                      <input type="radio" value="{{ card.tenderId }}" formControlName="tenderNumber" />
                      <div class="control_indicator"></div>
                    </label>
                  </div>
                  <div class="
                      fusion-layout-column
                      fusion_builder_column
                      fusion_builder_column_1_2
                      fusion-builder-nested-column-2
                      fusion-one-half
                      fusion-column-last
                      1_2
                      ng-tender-detail-link
                    " style="
                      margin-top: 10px;
                      margin-bottom: 10px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                    ">
                    <style type="text/css">
                      @media only screen and (max-width: 700px) {
                        .ng-div-detail-link {
                          margin-top: 0px !important;
                        }

                        .ng-detail-link {
                          padding-top: 0px !important;
                        }
                      }
                    </style>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fusion-sep-clear"></div>
        </div>
        <div class="modal-body fusion-clearfix" *ngIf="
            userTenders == null ||
            userTenders == undefined ||
            userTenders.length === 0
          ">
          <p style="text-align: center">Non hai ancora creato nessuna gara!</p>
        </div>
        <div class="modal-footer">
          <button type="button" style="border: 0; float: left" class="
              fusion-button
              button-default button-medium button
              default
              medium
            " *ngIf="showMoreTenders" (click)="loadMoreUserTenders()">
            MOSTRA ALTRE GARE
          </button>
          <button type="submit" style="border: 0" [disabled]="form.invalid" class="
              fusion-button
              button-default button-medium button
              default
              medium
            " *ngIf="
              userTenders != null &&
              userTenders != undefined &&
              userTenders.length !== 0
            ">
            INVIA INVITO
          </button>
        </div>
      </form>
    </div>

    <!-- CARDS -->
  </div>
</div>

<!-- UNAUTHORIZED MODAL -->
<app-modal #unauthorizedModal>
  <ng-template #header>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>{{ "Per accedere a quest area è necessario compilare tutti i dati del profilo azienda all'interno dell'area
        riservata" | uppercase }}</h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
          width: calc(100% - ((1%) * 0.5));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a (click)="unauthorizedModalSubmit()" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              " target="_self"><span class="fusion-button-text fusion-button-text-left">{{
                "APRI LA PAGINA DI PROFILO"
                }}</span></a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>

<!-- ERROR MODAL  -->

<div [ngStyle]="{ display: displayError }" class="fusion-modal modal fade modal-1 modal-invite in" tabindex="-1"
  role="dialog" id="invite-modal">
  <style type="text/css">
    .modal-1 .modal-header,
    .modal-1 .modal-footer {
      border-color: #ebebeb;
    }
  </style>
  <div class="modal-dialog modal-lg">
    <div class="modal-content fusion-modal-content" style="background-color: #f5f5f5">
      <div class="modal-header">
        <button class="close" type="button" (click)="changeModalError()">
          ×
        </button>
        <h3 class="modal-title fusion-responsive-typography-calculated" id="modal-heading-1" data-fontsize="28"
          data-lineheight="40.6px" style="--fontSize: 28; line-height: 1.45">
          {{ "Si è verificato un errore, riprova più tardi" | uppercase }}
        </h3>
      </div>
      <div class="modal-footer">
        <button (click)="changeModalError()" type="submit" style="border: 0" class="
            fusion-button
            button-default button-medium button
            default
            medium
          ">
          CHIUDI
        </button>
      </div>
    </div>
  </div>
</div>

<!-- SUCESS MODAL  -->
<div [ngStyle]="{ display: displaySuccess }" class="fusion-modal modal fade modal-1 modal-invite in" tabindex="-1"
  role="dialog" id="invite-modal">
  <style type="text/css">
    .modal-1 .modal-header,
    .modal-1 .modal-footer {
      border-color: #ebebeb;
    }
  </style>
  <div class="modal-dialog modal-lg">
    <div class="modal-content fusion-modal-content" style="background-color: #f5f5f5">
      <div class="modal-header">
        <button class="close" type="button" (click)="changeModalSuccess()">
          ×
        </button>
        <h3 class="modal-title fusion-responsive-typography-calculated" id="modal-heading-1" data-fontsize="28"
          data-lineheight="40.6px" style="--fontSize: 28; line-height: 1.45">
          {{ "Invito inviato con successo" | uppercase }}
        </h3>
      </div>
      <div class="modal-footer">
        <button (click)="changeModalSuccess()" type="submit" style="border: 0" class="
            fusion-button
            button-default button-medium button
            default
            medium
          ">
          CHIUDI
        </button>
      </div>
    </div>
  </div>
</div>